// extracted by mini-css-extract-plugin
export default {"ul":"j93yMml","li":"_3H4VztY"};